import {Component} from '@angular/core';

@Component({
    selector: 'app-styling-svg-login',
    templateUrl: './styling-svg-login.component.html',
    styleUrls: ['./styling-svg-login.component.scss'],
    standalone: false
})
export class StylingSvgLoginComponent {
}
